import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { createCandidate } from '../../store/slices/hrSlice';
import Layout from '../../components/Layout';
import { HR_CANDIDATE_STATUS } from '../../utils/constants';

const HRCandidateForm = () => {
  const { requirementId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const [formData, setFormData] = useState({
    requirement_id: requirementId,
    name: '',
    phone: '',
    email: '',
    experience: '',
    resume_url: '',
    status: HR_CANDIDATE_STATUS.APPLIED
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await dispatch(createCandidate(formData)).unwrap();
      navigate(`/hr/requirements/${requirementId}`);
    } catch (err) {
      setError(err.message || err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="container-fluid" style={{ maxWidth: '800px' }}>
        <button className="btn btn-outline-secondary mb-3" onClick={() => navigate(`/hr/requirements/${requirementId}`)}>
          <i className="ti ti-arrow-left me-1" />
          Back to Requirement
        </button>

        <div className="card">
          <div className="card-body">
            <h2 className="fs-5 mb-3">Add New Candidate</h2>

            {error && <div className="alert alert-danger">{error}</div>}

            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Full Name *</label>
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter candidate name"
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Email *</label>
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="candidate@example.com"
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Phone *</label>
                <input
                  type="tel"
                  name="phone"
                  className="form-control"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="1234567890"
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Experience *</label>
                <input
                  type="text"
                  name="experience"
                  className="form-control"
                  value={formData.experience}
                  onChange={handleChange}
                  placeholder="e.g., 5 years"
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Resume URL</label>
                <input
                  type="url"
                  name="resume_url"
                  className="form-control"
                  value={formData.resume_url}
                  onChange={handleChange}
                  placeholder="https://example.com/resume.pdf"
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Status *</label>
                <select
                  name="status"
                  className="form-select"
                  value={formData.status}
                  onChange={handleChange}
                  required
                >
                  {Object.values(HR_CANDIDATE_STATUS).map((status) => (
                    <option key={status} value={status}>
                      {status.replace(/_/g, ' ')}
                    </option>
                  ))}
                </select>
              </div>

              <div className="d-flex gap-2 justify-content-end mt-4">
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() => navigate(`/hr/requirements/${requirementId}`)}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? 'Adding...' : 'Add Candidate'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default HRCandidateForm;
